<div style="text-align:center">
  <div class="">
    <div class="col-12 text-center p-0">
      <input type="text" #textSearchInput class="form-control input-element-main-search" value="{{_value}}"
        [placeholder]="_placeholder | translate | async" autofocus />
    </div>
  </div>
  @if (isSearching) {
    <div class="position-absolute bg-white w-100" style="z-index: 2;">
      <div class="col-12 text-center">
        <h4>Searching ... </h4>
      </div>
    </div>
  }
  @if (apiResponse) {
    <div class="col-12 p-0 position-absolute search-item-container">
      @if (apiResponse['Response'] == 'False') {
        <div class="col-12">
          <div class="alert alert-danger" role="alert">
            {{apiResponse['Error']}}
          </div>
        </div>
      } @else {
        <div class="text-left">
          @if (showSuggestions) {
            <div class="col-12 p-0 search-result-container bg-white">
              @if (apiResponse.length <= 0) {
                <div class="no-data-found-for-search">No Data Found</div>
              }
              <!-- <div class="" *ngFor="let result of apiResponse; let i of index;"
              [class.active]="markIsActive(i, result)" (click)="handleSelectionClick(result.text, i)"> -->
              @for (result of apiResponse; track result; let iRow = $index) {
                <div
                  class='u-search-items position-relative border-bottom pl-3 pr-3 pb-1 pt-1'>
                  <input (change)="onItemChecked($event.target.checked, iRow)" [checked]="selectedIndices[iRow]"
                    type='checkbox' class='checkbox'>
                  <div class='u-name'>
                    <label>
                      <span>{{result.patient_name}}</span>
                      <span class='u-preRegistrationNo txt-13 pl-2 pr-1'>{{result.preRegistrationNo}}</span>
                    </label>
                  </div>
                  <span class='u-phone txt-13 pr-2'>{{result.telecom}}</span>
                  <span class='u-uhid txt-13 pl-2'>{{result.uhId}}</span>
                  <span class='u-age txt-13 pl-2'>{{result.patient_age}}</span>
                  <span class='u-gender txt-13'>{{result.patient_gender}}</span>
                </div>
              }
              <!-- <div class="col-12 text-center mt-4 card-footer-actions">
              <button type="button" class="primary-btn" (click)="getResult($event)">Submit</button>
            </div> -->
          </div>
        }
        <div class="checbox-wrapper mb-1">
          <button type="button" (click)="getResult($event)" class="primary-btn">
            Submit
          </button>
        </div>
        @if (fixLabel != '') {
          <div class="u-search-footer">
            <a href="javascript:void(0)" (click)="labelClick($event)">{{fixLabel.text}}</a>
          </div>
        }
      </div>
    }
  </div>
}
</div>